import { Col } from 'antd'
import styled from 'styled-components'

const ColStyled = styled(Col)`
  justify-content: space-between;
  display: flex;
`
export { ColStyled }
